import uploadToCDNRequest from '@picsart/cloud-storage/api/uploadToCDN';

import { MINIAPP_PACKAGE_ID } from '@/consts/configs';
import { ErrorMessages } from '@/consts/errors';
import { getContext } from '@/context';
import { getAppStore, setAppStore } from '@/store';
import { ToastType } from '@/store/toast/types';
import getAccessToken from '@/utils/user/getAccessToken';

const uploadFile = async (file: File) => {
  const accessToken = getAccessToken();
  if (!accessToken) {
    return null;
  }

  const { url } = await uploadToCDNRequest({
    file,
    accessToken,
    abortController: new AbortController(),
    headers: {
      ...getContext().utils.api.getHeaders(),
      'x-touchpoint': MINIAPP_PACKAGE_ID,
    },
  });

  return url;
};

const uploadToCDN = async (file: File) => {
  try {
    return await uploadFile(file);
  } catch {
    try {
      setAppStore({ isGenerating: true });
      await getContext().handlers.refreshToken();
      return await uploadFile(file);
    } catch {
      getAppStore().showToast(ErrorMessages.uploadToCDN, ToastType.Error);
      return null;
    } finally {
      setAppStore({ isGenerating: false });
    }
  }
};

export default uploadToCDN;
